import styled from 'styled-components';


export const SelectDiv = styled.div`
    display: flex;
    gap: 15px;
    align-items: center;
`

export const Checkbox = styled.input`
    accent-color: #3A98B9;
    width: 20px;
    height: 20px;
`
